<div class="terms-conditions-container">
  <cdk-virtual-scroll-viewport itemSize="50" class="terms-conditions-viewport">

    <div class="terms-conditions-section terms-conditions-text">
      <p>The undersigned confirms that the CAS registry numbers, and Index names are correct. Permission is granted to
        USAN to utilize this information in USAN-generated publications.</p>

      <p>Permission is granted for the USAN Council secretariat to secure an International Union of Pure and Applied
        Chemistry (IUPAC) or other systematic name for the compounds submitted. Please note that names appearing on the
        statement of adoption may differ from those submitted by the firm.</p>

      <p *ngIf="formType !='FormE'">Permission is granted for the USAN Council secretariat to submit the negotiated nonproprietary name to the
        World
        Health Organization (WHO) Nomenclature Committee for consideration. A fee of $12,000 assessed by the WHO is
        payable to the WHO via wire transfer; payment will be made when the name is forwarded to the WHO for
        consideration
        and wire transfer instructions will be provided upon request. If the name is already an International
        Nonproprietary Name (INN), permission is granted to forward it to WHO as a matter of information.</p>

      <p>This submission is made with the understanding that insofar as is known, none of the suggested names are
        trademarked or the subject of pending registration. It is further understood that the adopted USAN will remain
        free and unrestricted nonproprietary names that will not be trademarked. Furthermore, USAN stems should not be
        incorporated into a trade name.</p>

      <p>This submission is made with the understanding that names recommended by the USAN Council for this compound
        will
        be posted on the USAN Web site as "names under consideration."</p>

      <p>The undersigned understands and acknowledges that because “names under consideration” as well as adoption
        statements are published on the USAN Web site, there is a possibility that unaffiliated third parties might
        register a name as an Internet domain without the prior knowledge of the USAN Program. The undersigned waives
        all
        liability of USAN if this is to occur.</p>

      <p>The undersigned understands and acknowledges that all information included on the USAN application and provided
        by the applicant throughout the USAN negotiation process is kept confidential and is only shared with USAN
        staff,
        the USAN Council and the INN Expert Group.</p>

      <p>The undersigned agrees not to publicly use USAN name suggestions before receiving a Statement of Adoption from
        the USAN Council.</p>

      <p class="terms-conditions-text">PLEASE NOTE: After adoption, firms requesting changes to the
        sequence/CAS/structure/chemical information that is different from the submitted information before publication,
        MUST file a USAN Modified <span class="terms-conditions-note-text">(Form C: Modified compound form)</span>
        submission and pay the associated fee.</p>

      <p class="terms-conditions-text">To avoid this additional paperwork and fee, which is to cover the
        increased costs associated with re-reviews required when firms unexpectedly change the information associated
        with a compound, USAN Program staff strongly recommends that firms double-check all structural information for
        accuracy before submitting the USAN application.</p>
    </div>
  </cdk-virtual-scroll-viewport>
  <div class="terms-conditions-section">
    <p class="terms-conditions-featured-text">Once you click 'Agree and Submit Application,' you won't be able to make
      any changes to your application.</p>
  </div>

</div>